import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
// import Breadcrumb from './Breadcrumb'

import { useHistory } from "react-router-dom";
import { UserContext } from '../../MyContexts/Users_Context';
import MySpinner_Wait from '../../MySections/DTechComps/MySpinner_Wait';
import PageSelectImage from '../../MySections/ImagesSetter/PageSelectImage';
import SucessToast from '../../MySections/Toasts/SucessToast';



const ImageGallContent = (props) => {
    const history = useHistory();

    const [user, setUser] = useContext(UserContext)
    const [diag, setDiag] = useState("");

    const [loading, setLoading] = useState(true);
    let idParam = useParams();
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {
        setLoading(false)
    }, [])


    const updateTheProfile = async () => {
        // let HomePLst = await utilsHomePage.updateHomePage(homeP);
        // // setRest(rstLst);
        // setHomeP({ ...homeP })
        SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
    }




    return (
        <div className="ms-content-wrapper SetBlock">
            {/* <Breadcrumb /> */}
            {/* Active Orders Graph */}
            <div className="row">
                <div className="col-md-12">
                    {loading ? <MySpinner_Wait /> :
                        <>
                            <div className={"inDiag"}>
                                <PageSelectImage firstImg={""} handleClose={() => setDiag()}
                                    selectedImg=
                                    {(fUrl) => {
                                        setDiag();
                                    }} />

                            </div>
                        </>
                    }
                </div>
            </div>
            {thePopUp}
        </div>
    );
}


export default ImageGallContent;